import { DEFAULT_LOCALE, I18N_RESOURCES, type Locale } from './resources';

function getTranslation(locale: Locale, key: string): string | null {
  const source = I18N_RESOURCES[locale] as Record<string, unknown>;
  const value = key.split('.').reduce<unknown>((current, segment) => {
    if (current && typeof current === 'object' && segment in current) {
      return (current as Record<string, unknown>)[segment];
    }
    return null;
  }, source);

  return typeof value === 'string' ? value : null;
}

function interpolate(
  template: string,
  values?: Record<string, string>,
): string {
  if (!values) {
    return template;
  }

  return template.replace(/\{\{(\w+)\}\}/g, (_, key: string) => {
    return values[key] ?? '';
  });
}

export function translateForLocale(
  locale: Locale,
  key: string,
  values?: Record<string, string>,
): string {
  const translation =
    getTranslation(locale, key) ?? getTranslation(DEFAULT_LOCALE, key);
  if (!translation) {
    return key;
  }
  return interpolate(translation, values);
}
